"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarHasModificationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var InfoQuestionCollapseWrapper_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapper");
var core_1 = require("@athena-portal/core");
var Types_1 = require("@athena-portal/plugin-journey/dist/Types");
var journey_services_1 = require("@ferry/journey-services");
var CarHasModificationWidget = /** @class */ (function (_super) {
    __extends(CarHasModificationWidget, _super);
    function CarHasModificationWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.showInfoHandler = _this.showInfoHandler.bind(_this);
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        var hasMods = (_a = _this.props.interaction.vehicles[_this.vehicleIndex]) === null || _a === void 0 ? void 0 : _a.hasModifications;
        if (hasMods === undefined) {
            _this.state = {
                showInfo: false,
                hasModification: false,
                hasNoModification: false,
                modificationLookup: {},
            };
        }
        else {
            _this.state = {
                showInfo: false,
                hasModification: hasMods,
                hasNoModification: !hasMods,
                modificationLookup: {},
            };
        }
        return _this;
    }
    CarHasModificationWidget.prototype.componentDidMount = function () {
        var _a;
        (_a = _super.prototype.componentDidMount) === null || _a === void 0 ? void 0 : _a.call(this);
        if (this.lookupService) {
            this.fetchLookupValues("vehicleModification");
        }
        else {
            throw new Error("Lookup service is not available.");
        }
    };
    CarHasModificationWidget.prototype.render = function () {
        var _this = this;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex] || {};
        var rawModifications = vehicle.modifications || [];
        var isMigratedRenewal = this.props.interaction.status === journey_services_1.MIGRATED_RENEWAL_TEMP;
        var hasKnownModifications = isMigratedRenewal && rawModifications.length > 0;
        var vehicleDescription = "".concat(vehicle.make || "", ", ").concat(vehicle.model || "") +
            (vehicle.registrationNumber ? " (".concat(vehicle.registrationNumber, ")") : "");
        var mappedModifications = rawModifications.map(function (modId) {
            return _this.resolveLookupValue("vehicleModification", modId);
        });
        var baseQuestionText = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Does this ".concat(vehicleDescription, " have any modifications that we don\u2019t know about?") }));
        var label;
        var info;
        if (isMigratedRenewal) {
            if (hasKnownModifications) {
                label = ((0, jsx_runtime_1.jsxs)("span", { className: "vehicle-modifications-label", children: ["We are aware of the following modifications to your car:", (0, jsx_runtime_1.jsx)("ul", { className: "font-weight-normal", children: mappedModifications.map(function (mod, idx) { return ((0, jsx_runtime_1.jsx)("li", { children: mod }, "".concat(mod, "-").concat(idx))); }) }), baseQuestionText] }));
            }
            else {
                label = ((0, jsx_runtime_1.jsxs)("span", { className: "vehicle-modifications-label", children: ["We're not aware of any modifications to your car. ", (0, jsx_runtime_1.jsx)("br", {}), baseQuestionText] }));
            }
            info = this.renderHtml("\n            <div className=\"mt-2 font-weight-normal\">\n                You don\u2019t need to tell us about any factory fitted optional extras or any changes for\n                disabilities, air conditioning, fog lights, parking sensors and tow bars.\n            </div>\n            <br/>\n          <strong>Your previous insurance may have named these modifications differently. We no longer take into account any factory fitted optional extras.</strong>\n          <br/><p>We cover cars with disability modifications, air conditioning, fog lights, parking sensors and tow bars.<br/>\n          We don't cover other modifications (unless already specified above), which include, but aren't restricted to:</p>\n          <ul>\n              <li>bodywork, such as spoilers or body kits</li>\n              <li>suspension or brakes</li>\n              <li>cosmetics, such as alloy wheels</li>\n              <li>performance, such as engine and exhaust.</li>\n          </ul>");
        }
        else {
            label = ((0, jsx_runtime_1.jsx)("span", { className: "vehicle-modifications-label", children: "Does this ".concat(vehicleDescription, " have any modifications, other than for disabilities, air conditioning, fog lights, parking sensors and tow bars?") }));
            info = this.renderHtml("\n          <p>We cover cars with disability modifications, air conditioning, fog lights, parking sensors and tow bars.<br />\n          We don't cover other modifications, which include, but aren't restricted to:</p>\n          <ul>\n              <li>bodywork, such as spoilers or body kits</li>\n              <li>suspension or brakes</li>\n              <li>cosmetics, such as alloy wheels</li>\n              <li>performance, such as engine and exhaust.</li>\n          </ul>");
        }
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionCollapseWrapper_1.InfoQuestionCollapseWrapper, { label: label, info: info, children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    CarHasModificationWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Does your car have any modifications, other than for disabilities?", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "hasModification-true", id: "hasModificationstrue", value: "true", checked: this.state.hasModification, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "hasModificationstrue", children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "hasModification-false", id: "hasModificationsfalse", value: "false", checked: this.state.hasNoModification, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "hasModificationsfalse", children: "No" })] })] }));
    };
    CarHasModificationWidget.prototype.handleOnChangeEvent = function (event) {
        var carHasModification = event.target.value === "true";
        if (carHasModification) {
            this.props.onStateChange(this.props.question.interactionField, true);
            this.setState({
                hasModification: true,
                hasNoModification: false,
            });
        }
        else {
            this.props.onStateChange(this.props.question.interactionField, false);
            this.setState({
                hasModification: false,
                hasNoModification: true,
            });
        }
        _super.prototype.validateInternal.call(this, event.target.value);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    CarHasModificationWidget.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService
            .fetchLookupValues(lookupName, "en-UK")
            .subscribe(function (lookupValues) {
            var _a;
            var updatedLookup = __assign(__assign({}, _this.state.modificationLookup), (_a = {}, _a[lookupName] = lookupValues, _a));
            _this.setState({ modificationLookup: updatedLookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    CarHasModificationWidget.prototype.resolveLookupValue = function (lookupName, lookupId) {
        var _a;
        if (!lookupId) {
            return "";
        }
        var lookup = (_a = this.state.modificationLookup) === null || _a === void 0 ? void 0 : _a[lookupName];
        if (!lookup) {
            return lookupId;
        }
        var item = lookup.find(function (entry) { return "".concat(entry.id) === "".concat(lookupId); });
        return item ? item.value : lookupId;
    };
    CarHasModificationWidget.prototype.showInfoHandler = function () {
        this.setState({
            showInfo: !this.state.showInfo
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.LookupService),
        __metadata("design:type", Object)
    ], CarHasModificationWidget.prototype, "lookupService", void 0);
    return CarHasModificationWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.CarHasModificationWidget = CarHasModificationWidget;
//# sourceMappingURL=CarHasModificationWidget.js.map